import { ParameterIDNotValid } from 'app/constants/error_codes'
import ErrorMessages from 'app/constants/error_messages'
import { history } from 'app/shared_components/router'
import {
  RECEIVE_RESPONSE_TEXT,
  receiveError,
} from 'app/sm/profile/profile_actions'

const ProfileMiddleware = (store) => (next) => (action) => {
  let { type, responseText } = action
  let errorCode = parseInt(responseText)
  let errorMessage = ErrorMessages[errorCode]

  if (errorCode === ParameterIDNotValid) {
    history.replace('/404')
    return
  }

  switch (type) {
    case RECEIVE_RESPONSE_TEXT:
      if (errorMessage) {
        store.dispatch(receiveError(errorMessage))
        return next(action)
      }
      if (isNaN(responseText)) {
        store.dispatch(receiveError(responseText))
        return next(action)
      }

      store.dispatch(
        receiveError(`There was a problem. Error code: ${errorCode}`),
      )
      return next(action)

    default:
      return next(action)
  }
}

export default ProfileMiddleware
